module.exports = __webpack_public_path__ + "img/prj-card3.619d803c.png";